// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__oHQy8","order__number":"order-details_order__number__gassa"};